<template>
  <div class="h5" style="padding-top: 50px;">
    <div class="banner">
      <img src="../../static/image/developbanner.png" alt />
    </div>
    <div class="contenter">
        <Timeline class="box" >
                <Timeline-item  class="spacing" v-for='item in development_list' :key='item.content'>
                    <img src="../../static/image/point.png" alt="" slot="dot">
                    <p class="time">{{item.develop_time}}</p>
                    <p class="content">{{item.content}}</p>
                </Timeline-item>
        </Timeline>     
    </div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "htmls",
  data() {
    return {
      development_list: [],
      big_img:'',
      isShow:false
    };
  },
  components: {
    xfck
  },
  created() {
    this.get_course();
  },
  methods: {
    get_course() {
      var that = this;
      var url = that.baseUrl + "/jianyun/api/mall.php?c=development_history/getDevelopmentList";
      that.axios
        .get(url, {
          params: {
            pic_type: 2
          }
        })
        .then(res => {
          if (res.data.success) {
            that.development_list = res.data.data.list
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },

  },
  mounted() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  width: 100%;
}
.banner > img {
  width: 100%;
  height: 100%;
}
.contenter{
    padding: 30px 0;
    min-height: 500px;
}
.box{
    width: 800px;
    margin: 0 auto;
}
.spacing{
   height: 130px;
  
}
.time{
    color: #FD7B35;
    font-size: 18px;
}
.content{
    color: #666666;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/course.vue